/**
 * Cuenta
 *
 * @author edmsamuel
 */
import { APP_ACCOUNT_SET, APP_ACCOUNT_CLOSE, APP_ACCOUNT_ERROR } from '../actions/cuenta';
import Api from '../Api';

const initialState = {
  error: null,
  nombre: null,
  correoElectronico: null,
  imagen: Api.to('/cmr/organizacion/image-file/imagen'),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case APP_ACCOUNT_SET:
      return {
        ...initialState,
        ...action.data,
      }

    case APP_ACCOUNT_CLOSE:
      Api.removeUserData();
      return initialState;

    case APP_ACCOUNT_ERROR:
      return {
        ...initialState,
        error: action.data
      }

    default:
      return state;
  }
}
